import { useFacet } from './useFacet';

export const useNbFacetValues = (facetName: string): number => {
  const { facet } = useFacet(facetName);

  return facet?.values.length || 0;
};
